<template>
  <div @dragover.prevent="test($event)" class="viewing-discipline-section">
    <h4 class="page-title">Материалы.</h4>
    <div class="viewing-discipline-section__content">
      <ul class="viewing-discipline-section__list-root">
        <tree-item
          :title="title"
          :readOnly="readOnly"
          draggable="true"
          class="discipline-item"
          :item="treeData"
        />
      </ul>
      <transition name="fade">
        <ul
          class="action-bord"
          v-if="showMenu && !readOnly"
          dropzone="copy"
          @drop.prevent="handleFileUpload($event)"
        >
          <li
            class="action-bord__drop-zone"
            id="drop-zone"
            :style="styleHeightDropZone"
          >
            <i class="item-icon el-icon-upload2" id="drop-zone-icon"></i>
            <el-button @click="cancelDrop" id="drop-zone-btn"
              >Отмена загрузки</el-button
            >
          </li>
          <li
            :class="[
              'action-bord__item',
              { actionBordItemIsActive: inputEditItem },
            ]"
            v-if="selectedElement.type !== 'template' && selectedElement.level"
            @click="activeInputEditName($event)"
          >
            <i
              class="action-bord__item-icon el-icon-edit"
              v-if="!inputEditItem"
            ></i>
            <span class="action-bord__item-text" v-if="!inputEditItem"
              >Редактировать название</span
            >
            <input
              class="action-bord__item-input"
              v-model="nameFolder"
              type="text"
              v-if="inputEditItem"
            />
            <el-button
              class="action-bord__item-button"
              type="text"
              icon="el-icon-circle-check"
              @click="confirmEditItem($event, true)"
              v-if="inputEditItem"
            ></el-button>
            <el-button
              class="action-bord__item-button"
              type="text"
              style="margin: 0"
              icon="el-icon-circle-close"
              @click="confirmEditItem($event, false)"
              v-if="inputEditItem"
            ></el-button>
          </li>
          <li
            :class="[
              'action-bord__item',
              { actionBordItemIsActive: inputAddItem },
            ]"
            @click="htmlEditorRun()"
            v-if="extensionSelectedElement"
          >
            <i class="action-bord__item-icon el-icon-reading"></i>
            <span class="action-bord__item-text">Открыть в редакторе</span>
          </li>
          <li
            :class="[
              'action-bord__item',
              { actionBordItemIsActive: inputAddItem },
            ]"
            v-if="selectedElement.level < 2"
            @click="activeInputAddItem($event)"
          >
            <i
              class="action-bord__item-icon el-icon-circle-plus-outline"
              v-if="!inputAddItem"
            ></i>
            <span class="action-bord__item-text" v-if="!inputAddItem"
              >Добавить раздел</span
            >
            <input
              class="action-bord__item-input"
              v-model="nameFolder"
              type="text"
              v-if="inputAddItem"
            />
            <el-button
              class="action-bord__item-button"
              type="text"
              icon="el-icon-circle-check"
              @click="confirmAddItem($event, true)"
              v-if="inputAddItem"
            ></el-button>
            <el-button
              class="action-bord__item-button"
              type="text"
              style="margin: 0"
              icon="el-icon-circle-close"
              @click="confirmAddItem($event, false)"
              v-if="inputAddItem"
            ></el-button>
          </li>
          <li
            :class="['action-bord__item']"
            @click="htmlEditorRun()"
            v-if="permissionToCreateTpl"
          >
            <i class="action-bord__item-icon el-icon-document-add"></i>
            <span class="action-bord__item-text">Добавить HTML</span>
          </li>
          <li
            @click="submitFile($event)"
            :class="['action-bord__item', 'upload', { uploadFileDone: file }]"
            v-if="permissionToUploadFile"
          >
            <ul
              :class="['uploaded-file__list', file ? 'file__list-show' : null]"
              :style="styleHeightFileList"
            >
              <li v-for="(item, index) in file" :key="index">
                <button @click.stop="removeUploadingFile(index)">
                  <i class="el-icon-close"></i>
                </button>
                <i class="far fa-file-alt"></i>
                <span>{{ item.name }}</span>
              </li>
            </ul>
            <div class="upload-file">
              <label
                for="file"
                class="upload-file__label"
                :style="{ width: widthUploadInput + '%' }"
              >
                <i class="action-bord__item-icon el-icon-upload2"></i>
                <div v-if="!file">
                  <span class="upload-file__label-text"
                    >Переместите файлы сюда</span
                  >
                  <span class="upload-file__label-text">или</span>
                  <span class="upload-file__label-text is-blue"
                    >Кликните для загрузки</span
                  >
                </div>
                <button class="upload-file__button" v-if="file">
                  Отправить
                </button>
              </label>
              <el-button
                class="action-bord__button-close"
                type="text"
                icon="el-icon-close"
                @click.stop="cancelUpload($event)"
                v-if="file"
              ></el-button>
              <input
                class="upload-file__input"
                multiple
                type="file"
                id="file"
                ref="file"
                v-if="!file"
                @change="handleFileUpload()"
              />
            </div>
          </li>
          <a
            class="action-bord__item"
            v-if="selectedElement.type === 'file'"
            :href="selectedElement.body"
          >
            <i class="el-icon-download"></i>
            <span class="action-bord__item-text">Скачать файл</span>
          </a>
          <li
            class="action-bord__item"
            v-if="selectedElement.level"
            @click="runNotifyDelete"
          >
            <i class="action-bord__item-icon el-icon-delete"></i>
            <span class="action-bord__item-text">Удалить</span>
            <transition name="fade">
              <div class="cart-delite__confirm" v-if="popConfirm">
                <div class="cart-delite__confirm-text">
                  <span class="cart-delite-symbol">!</span>
                  <h5>Подтвердите удаление</h5>
                </div>
                <el-button
                  @click="confirmDelite($event, false)"
                  plain
                  size="mini"
                  >Нет</el-button
                >
                <el-button
                  @click="confirmDelite($event, true)"
                  type="primary"
                  size="mini"
                  >да</el-button
                >
              </div>
            </transition>
          </li>
          <li class="action-bord__item" @click="menuHide()" v-if="mobileMode">
            <span></span>
            <span class="action-bord__item-text">Назад</span>
          </li>
        </ul>
      </transition>
    </div>
    <transition name="fade">
      <html-editor
        :readOnly="false"
        :defaultValue="selectedElementBody"
        :pathToFile="selectedElement.path"
        class="html-editor-window"
        v-if="htmlEditorActive"
      />
    </transition>
  </div>
</template>

<script>
import htmlEditor from "../htmlEditor/App";
import { mapActions, mapMutations } from "vuex";
export default {
  name: "ViewingDiscipline",
  data() {
    return {
      dragStart: false,
      dropRedy: false,
      file: "",
      nameFolder: "",
      inputEditItem: false,
      inputAddItem: false,
      uploadButtonActive: false,
      urlUpload: `/api/disciplines/${this.$route.params.did}/materials`,
      popConfirm: false,
    };
  },
  components: {
    "tree-item": () => import("./itemTree"),
    "html-editor": htmlEditor,
  },
  props: {
    readOnly: Boolean,
    title: String,
  },
  computed: {
    htmlEditorActive() {
      return this.$store.state.viewingDiscipline.htmlEditorActive;
    },
    styleHeightDropZone() {
      return {
        height: this.dragStart ? 98 + "%" : 0 + "px",
        visibility: this.dragStart ? "visible" : "hidden",
        borderColor: this.dropRedy ? "#0288D1" : "#909399",
        opacity: this.dragStart ? 1 : 0,
        color: this.dropRedy ? "#0288D1" : "#909399",
      };
    },
    styleHeightFileList() {
      if (this.file) {
        return {
          height: this.file.length * 40 + "px",
          opacity: "1",
        };
      } else {
        return {
          height: "0px",
          opacity: "0",
        };
      }
    },
    widthUploadInput() {
      return this.file ? 80 : 100;
    },
    selectedElementBody() {
      return this.selectedElement ? this.selectedElement.body : "";
    },
    permissionToCreateTpl() {
      return (
        this.checkOnFolder &&
        !this.selectedElement.children.length &&
        this.selectedElement.level !== 0 &&
        !this.checkFolderOnTpl
      );
    },
    permissionToUploadFile() {
      return (
        this.checkOnFolder &&
        this.selectedElement.level !== 0 &&
        !this.checkFolderOnTpl
      );
    },
    checkOnFolder() {
      return this.selectedElement.type === "directory";
    },
    checkFolderOnTpl() {
      if (this.selectedElement.children) {
        let result = this.selectedElement.children.find(
          (el) => el.type === "template"
        );
        return result ? true : false;
      }
    },
    extensionSelectedElement() {
      if (this.selectedElement.extension) {
        return this.selectedElement.extension === "tpl" ? true : false;
      } else {
        return false;
      }
    },
    treeData() {
      return this.$store.state.viewingDiscipline.treeData;
    },
    selectedElement() {
      return this.$store.state.viewingDiscipline.selectedItem;
    },

    showMenu() {
      return this.selectedElement ? true : false;
    },
    mobileMode() {
      return this.$store.state.mobileMode;
    },
  },
  methods: {
    ...mapMutations([
      "setModalData",
      "setBlockScroll",
      "setHtmlEditorActive",
      "setSelectedItem",
    ]),
    ...mapActions([
      "fetchDataDiscipline",
      "createItemDiscipline",
      "deliteItemDiscipline",
      "editItemDiscipline",
      "saveFile",
    ]),
    runNotifyDelete() {
      this.notifyManual(
        ` <p style="line-height: 1.5;">По вопросам удаления и редактирования материалов дисциплины и тестов, обратитесь в Отдел цифровизации по адресу: <span style="color:#0288D1;">instudy@open-college.ru</span></p>`
      );
    },
    menuHide() {
      this.$store.commit("setSelectedItem", null);
    },
    cancelDrop() {
      (this.dragStart = false), (this.dropRedy = false);
    },
    test(e) {
      this.dragStart = true;
      this.dropRedy =
        e.target.id === "drop-zone" ||
        e.target.id === "drop-zone-btn" ||
        e.target.id === "drop-zone-icon"
          ? true
          : false;
    },
    htmlEditorRun() {
      this.setHtmlEditorActive(true);
      this.setBlockScroll(true);
    },
    handleFileUpload(event) {
      this.file ? null : (this.file = []);
      let filesInput = event ? event.dataTransfer.files : this.$refs.file.files;
      this.cancelDrop();
      filesInput.forEach((el) => {
        let check = this.file.find((elFind) => elFind.name == el.name);
        check
          ? this.notify(false, `Файл с именем ${check.name} уже есть в списке`)
          : this.file.push(el);
      });
    },
    removeUploadingFile(index) {
      this.file.splice(index, 1);
      this.file.length ? null : (this.file = "");
    },
    submitFile(e) {
      if (this.file) {
        const data = new FormData();
        let names = [];
        this.file.forEach((el, index) => {
          names.push(el.name);
          data.append("files[" + index + "]", el);
        });
        data.append("type", "file");
        data.append("path", this.selectedElement.path);
        data.append("names", names);
        let path = this.urlUpload;
        this.saveFile({ path, data }).then((res) => {
          this.notify(res.status, res.message);
          this.file = "";
          if (!res.status) {
            this.notifyManual(` <h5>Допустимые типы файлов для загрузки:</h5>
                                <ul>
                                  <li>DOC</li>
                                  <li>DOCX</li>
                                  <li>PDF</li>
                                  <li>TXT</li>
                                  <li>TPL</li>
                                </ul>`);
          }
        });
      }
    },
    cancelUpload(e) {
      e.stopPropagation();
      this.file = "";
      setTimeout(() => {
        this.$refs.file.value = "";
      }, 100);
    },
    activeInputEditName() {
      if (!this.inputEditItem) {
        this.nameFolder = this.checkOnFolder
          ? this.selectedElement.lable
          : this.nameFolderFunc("split");
        this.inputAddItem = false;
        this.inputEditItem = true;
      }
    },
    activeInputAddItem() {
      this.inputEditItem = false;
      this.inputAddItem = true;
    },
    activeUploadFile(e) {
      this.inputEditItem = false;
      this.inputAddItem = false;
      this.uploadButtonActive = true;
    },
    confirmAddItem(e, value) {
      e.stopPropagation();
      if (value && this.checkNameFolder()) {
        let dataObject = {
          path: this.selectedElement.path,
          names: this.nameFolder,
          type: "directory",
          disciplineId: this.$route.params.did,
        };
        this.createItemDiscipline(dataObject).then((res) => {
          this.notify(res.status, res.message);

          this.inputAddItem = false;
          this.nameFolder = "";
        });
      } else if (value && !this.checkNameFolder()) {
        this.notify(false, "Некорректное имя");

        this.notifyManual(` <h5>Имя файла или папки:</h5>
                              <ul>
                                <li>Не должно начинаться с цифры или символа</li>
                                <li>Должно быть длиннее 2х символов</li>
                                <li>Не должно быть пустым</li>
                              </ul>`);
      } else {
        this.inputAddItem = false;
        this.nameFolder = "";
      }
    },
    confirmEditItem(e, value) {
      this.checkNameFolder();
      e.stopPropagation();
      if (value && this.checkNameFolder()) {
        let newNameFolder = this.checkOnFolder
          ? this.nameFolder
          : this.nameFolderFunc("join");
        let dataObject = {
          path: this.selectedElement.path,
          name: newNameFolder,
          type: this.selectedElement.type,
          disciplineId: this.$route.params.did,
        };

        this.editItemDiscipline(dataObject).then((res) => {
          this.notify(res.status, res.message);
          if (res.status) {
            this.inputEditItem = false;
            this.nameFolder = "";
          }
        });
      } else if (value && !this.checkNameFolder()) {
        this.notify(false, "Некорректное имя");
      } else {
        this.inputEditItem = false;
        this.nameFolder = "";
      }
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    notify(status, text) {
      const h = this.$createElement;
      this.$notify({
        title: "",
        message: h(
          "i",
          { style: `color: ${status ? "#67C23A" : " #f56c6c"}` },
          text
        ),
      });
    },
    notifyManual(text) {
      this.$message({
        duration: 0,
        showClose: true,
        dangerouslyUseHTMLString: true,
        message: text,
      });
    },

    onDrop(e) {
      this.popConfirm = true;
      this.deletedItemPath = e.dataTransfer.getData("itemPath");
    },
    nameFolderFunc(marker) {
      if (marker === "split") {
        let arrName = this.selectedElement.lable.split(".");
        return arrName
          .filter((el, index) => {
            return index !== arrName.length - 1;
          })
          .join(".");
      } else if (marker === "join") {
        let arrName = this.selectedElement.lable.split(".");
        let extension = arrName[arrName.length - 1];
        return this.nameFolder + "." + extension;
      }
    },
    checkNameFolder() {
      let re = /^[A-Za-zА-яа-я]/;
      let reResult = re.test(this.nameFolder);
      return reResult && this.nameFolder.length >= 3;
    },
    confirmDelite(e, value) {
      e.stopPropagation();
      if (value) {
        let obj = {
          name: "createRequest",
          data: null,
        };
        this.setModalData(obj);
      }
      this.popConfirm = false;
    },
  },
  mounted() {
    this.fetchDataDiscipline(`api/disciplines/${this.$route.params.did}?type=${this.$route.query.type}`);
  },
  beforeDestroy() {
    this.setSelectedItem(null);
  },
};
</script>

<style lang="scss">
.viewing-discipline-section {
  overflow-y: auto;
  width: 100%;
  height: 100%;
  &__content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: max-content;
    max-width: 100%;
  }
  &__list {
    padding-left: 3em;
    list-style: none;
  }
  &__list-root {
    list-style: none;
    width: 100%;
  }
  .action-bord {
    height: 100%;
    position: fixed;
    right: 30px;
    top: 30px;
    align-items: center;
    z-index: 10;
  }
  .action-bord__drop-zone {
    border-radius: 10px;
    transition-duration: 0.3s;
    background-color: $basic-white;
    list-style: none;
    position: absolute;
    top: -2.5%;
    left: -2.5%;
    width: 98%;
    border: 2px dashed $secondary-text-clr;
    z-index: 8;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    i {
      text-align: center;
      font-size: 75px;
      width: 100%;
      display: block;
    }
  }
  .action-bord__item {
    background-color: $basic-white;
    position: relative;
    cursor: pointer;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
    padding: 10px;
    display: grid;
    grid-template-columns: 30px 1fr 30px;
    align-items: center;
    text-align: center;
    border-radius: 10px;
    width: 280px;
    height: 41px;
    z-index: 6;
    &:hover {
      background-color: $extra-light-border;
      .action-bord__item-input {
        background-color: $extra-light-border;
      }
    }
    .action-bord__button-close {
      background-color: $basic-white;
      padding: 0;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      justify-content: center;
      align-items: center;
    }
    .action-bord__item-text {
      color: $regular-text-clr;
      font-size: 17px;
    }
    .action-bord__item-input {
      font-size: 17px;
      outline: none;
      border: none;
      border-bottom: 1px solid $placeholder-text-clr;
    }
    .action-bord__item-icon {
      font-size: 18px;
      color: $regular-text-clr;
    }
    .action-bord__item-button {
      padding: 0;
      i {
        font-size: 22px;
      }
    }
  }
  .upload-file__label-icon {
    color: $regular-text-clr;
  }
  .upload {
    grid-template-columns: 1fr;
    padding: 0;
    position: relative;
    height: auto;
  }
  .uploaded-file__list {
    transition-duration: 0.3s;
    background-color: $basic-white;
    position: absolute;
    top: 0;
    border-radius: 10px;
    right: 105%;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
    z-index: 5;
    li {
      display: grid;
      grid-template-columns: 20px 20px max-content;
      color: $regular-text-clr;
      padding: 10px;
      align-items: center;
      justify-items: center;
      height: 40px;
      i {
        color: $placeholder-text-clr;
        padding: 0;
      }
      span {
        padding: 0 5px;
        justify-self: start;
      }
      button {
        i {
          color: $brand-clr-1;
          font-size: 15px;
          &:hover {
            color: lighten($color: $brand-clr-1, $amount: 10%);
          }
        }
      }
    }
  }
  .uploaded-file__list::after {
    content: "";
    position: absolute;
    border: 10px solid transparent;
    border-top: 10px solid $basic-white;
    top: 10px;
    right: -20px;
    transform: rotate(-90deg);
  }
  .uploadFileDone {
    background-color: $success-clr;
    color: $basic-white;
    .el-icon-upload2 {
      color: $basic-white;
    }
    &:hover {
      background-color: lighten($color: $success-clr, $amount: 10%);
    }
    .upload-file__button {
      color: $basic-white;
    }
  }
  .upload-file {
    display: flex;
    position: relative;
    padding: 10px;
    justify-content: space-between;
  }
  .upload-file__label {
    cursor: pointer;
    display: grid;
    grid-template-columns: 30px auto;
    align-items: center;
    text-align: center;
  }
  .upload-file__input {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    visibility: hidden;
    position: absolute;
  }
  .upload-file__label-text {
    display: block;
    padding: 2px 0;
    color: $regular-text-clr;
    font-size: 17px;
  }
  .is-blue {
    color: $brand-clr-1;
  }
  .upload-file__button {
    cursor: pointer;
    font-size: 14px;
    margin-left: 20px;
  }
  .actionBordItemIsActive {
    grid-template-columns: 1fr 30px 30px;
  }
  .actionBordUploadFile {
    button {
      margin: 0 5px;
    }
    grid-template-columns: 1fr;
  }
  .cart-delite__confirm {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 10px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    position: absolute;
    flex-wrap: wrap;
    bottom: -100px;
  }
  .cart-delite__confirm-text {
    justify-content: center;
    width: 100%;
    display: flex;
    align-items: center;
    h5 {
      text-align: center;
      margin: 0;
      padding: 10px 20px 10px 10px;
    }
    .cart-delite-symbol {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: red;
      color: $basic-white;
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }
  }
  .html-editor-window {
    padding: 0 10px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: $basic-white;
    z-index: 22;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
  }
}
@media (max-width: 800px) {
  .viewing-discipline-section {
    &__content {
      width: 100%;
    }
    .action-bord {
      display: flex;
      flex-direction: column;
      justify-content: center;
      z-index: 20;
      right: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
      .action-bord__item {
        background-color: $basic-white;
      }
      .uploadFileDone {
        background-color: $success-clr;
        color: $basic-white;
        .el-icon-upload2 {
          color: $basic-white;
        }
        &:hover {
          background-color: lighten($color: $success-clr, $amount: 10%);
        }
        .upload-file__button {
          color: $basic-white;
        }
      }
      .action-bord__item-input {
        width: 100%;
      }
      .action-bord__item-button {
        i {
          font-size: 24px;
        }
      }
    }
    .cart-delite__confirm {
      z-index: 20;
      background-color: white;
      button {
        margin: 0 15px;
      }
    }
  }
}
</style>